import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20geometric%20landscape%20with%20flowing%20gradients%20of%20warm%20amber%20and%20soft%20teal%20tones%20modern%20minimalist%20digital%20art%20with%20smooth%20curves%20and%20layered%20translucent%20shapes%20ethereal%20atmosphere%20clean%20composition&width=1600&height=900&seq=hero-91n-main&orientation=landscape"
          alt="91n.com 官方平台 - 海量资源与优质服务"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-6">
          探索无限可能，尽在
          <strong className="text-primary-400"> 91n.com</strong>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          值得信赖的在线平台，为您提供海量优质内容与专属会员服务。
          安全稳定、便捷高效，随时随地畅享极致数字体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 text-white border border-white/30 font-medium rounded-md hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-white">500万+</div>
            <div className="text-xs mt-1">注册用户</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl font-bold text-white">10万+</div>
            <div className="text-xs mt-1">优质文章</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl font-bold text-white">8</div>
            <div className="text-xs mt-1">内容板块</div>
          </div>
        </div>
      </div>
    </section>
  );
}